import { Component } from '@angular/core';
import { NavController, NavParams, ToastController } from 'ionic-angular';

import { BusinessInvoiceHandler } from '../../providers/business-invoice-handler';
import { BusinessProductExpeditorHandlerProvider } from '../../providers/business-product-expeditor-handler';
import { BusinessProductExpediterInvoiceDetailPage } from '../../pages/business-product-expediter-invoice-detail/business-product-expediter-invoice-detail';

@Component({
  selector: 'page-business-product-expediter-invoice-list',
  templateUrl: 'business-product-expediter-invoice-list.html',
})
export class BusinessProductExpediterInvoiceListPage {
	term: any = "";

	isRefreshing: boolean = false;
	isLoading: boolean = false;
	
	loadingMsg: any = "Loading...";

	lastRequestReturnedValues: boolean = false;

	hasData: boolean = true;	

	interval: any;

	constructor(
		public businessInvoiceHandler: BusinessInvoiceHandler,
		public mainHandler: BusinessProductExpeditorHandlerProvider,
		public navCtrl: NavController, 
		public toastCtrl: ToastController,
		public navParams: NavParams) {
		this.load(null)
	}

	ionViewDidEnter(){
		
		this.intervalInit()
  }

  ionViewDidLeave() {
    clearInterval(this.interval);
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad LeagueMatchesPage');
  }

	doRefresh(refresher) {
		// this.isRefreshing = true;

		clearInterval(this.interval);
				
		this.load(()=>{
		  refresher.complete();

	    this.intervalInit()
		})
	}  	

	intervalInit() {
    this.interval = setInterval(() => {
      this.load(null)
    }, 15000);
  }

	load(cb){
		// this.isLoading = (!this.isRefreshing) ? true : false;

		this.mainHandler.getOpenOrders({term: this.term})
		.then((data: any)=>{
			var list = data.Data;	
			
			this.hasData = (list.length == 0) ? false : true;
			this.lastRequestReturnedValues = (list.length==0) ? false : true;

			// this.isLoading = false;			

			if(typeof cb == "function") cb();
		})
		.catch((err)=>{
			this.isLoading = false;	

			let toast = this.toastCtrl.create({
				message: 'There was an error: ' + err,
				duration: 3000,
				position: 'bottom'
			});

			toast.present();	
		});
	}	

	viewDetail(invoice){
		this.navCtrl.push(BusinessProductExpediterInvoiceDetailPage, {invoice: invoice});		
	}  

	search(ev){
		this.term = this.term = ev.target.value;	

		if(this.term=="" || !this.term)
			this.term = "";
		
		this.load(null);
	}

}



// WEBPACK FOOTER //
// ./src/pages/business-product-expediter-invoice-list/business-product-expediter-invoice-list.ts